// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2omXa","header":"PatientBlock_header__1_f8g","label":"PatientBlock_label__1M67I","option":"PatientBlock_option__2vfdN"};